import { DiCss3, DiJavascript, DiNpm, DiPython } from "react-icons/di";
import { FaList, FaRegFolder, FaRegFolderOpen } from "react-icons/fa";
import { VscFile } from "react-icons/vsc";

export const FolderIcon = ({ isOpen }) =>
	isOpen ? (
		<FaRegFolderOpen color="e8a87c" className="icon" />
	) : (
		<FaRegFolder color="e8a87c" className="icon" />
	);

export const FileIcon = ({ filename }) => {
	const extension = filename.slice(filename.lastIndexOf(".") + 1);
	switch (extension) {
		case "js":
			return <DiJavascript color="yellow" className="icon" />;
		case "css":
			return <DiCss3 color="turquoise" className="icon" />;
		case "json":
			return <FaList color="yellow" className="icon" />;
		case "npmignore":
			return <DiNpm color="red" className="icon" />;
		case "py":
			return <DiPython color="blue" className="icon" />;
		default:
			return <VscFile color="white" className="icon" />;
	}
};
